import styles from "./style.module.scss";
import AccessImage from "src/assets/access.jpg";

export const AccessSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <iframe
          title="石巻マリンヴィレッジ"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.590978978508!2d141.26499387735384!3d38.42781667182816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f89a30062723d93%3A0x57ec5409f986c52f!2z55-z5be744Oe44Oq44Oz44O044Kj44Os44OD44K4!5e0!3m2!1sja!2sjp!4v1711700000000!5m2!1sja!2sjp"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <p className={styles.address}>
          住所：〒986-0848 宮城県石巻市新館3丁目4−18
        </p>
        <img
          src={AccessImage}
          alt="AccessImage"
          className={styles.accessImage}
        />
        <p className={styles.boxTitle}>公共交通機関でお越しの場合</p>
        <p className={styles.boxText}>所要時間：仙台駅より約1時間半</p>
        <ul>
          <li>
            <p>・電車の場合</p>
            <p>
              　仙台駅→石巻駅→ミヤコーバス「大街道新橋」バス停→石巻マリンヴィレッジ
            </p>
          </li>
          <li>
            <p>・飛行機の場合</p>
            <p>
              　仙台空港→石巻駅→ミヤコーバス「大街道新橋」バス停→石巻マリンヴィレッジ
            </p>
          </li>
        </ul>
        <a
          href="https://www.city.ishinomaki.lg.jp/cont/10053500/bus/20130322165030.html"
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          　<span>ミヤコーバス免許センター線の時刻表はこちら</span>
        </a>

        <p className={styles.boxTitle}>お車でお越しの場合</p>
        <p className={styles.boxText}>
          所要時間：仙台市より約1時間
          <br />
          三陸自動車道石巻港IC→石巻マリンヴィレッジ
          <br />
          *敷地内に無料駐車場あり
        </p>
      </div>
    </section>
  );
};
